
const images = (folder, lang) => {
    let listImg = [];
    if (process.env.NODE_ENV === 'development') {
        for(let i = 1; i < 553; i++){
            listImg.push(`http://localhost:8081/media/${lang}/saphirVideo1/saphir_home_${i}.jpg`)
        }
    } else {
        for(let i = 1; i < 553; i++){
            listImg.push(`https://www.dioptase.fr/media/${lang}/saphirVideo1/saphir_home_${i}.jpg`)
        }
    }
    return listImg;
}
export default images;
